import { render, staticRenderFns } from "./UndoDeleteFaq.vue?vue&type=template&id=4641d4a2"
import script from "./UndoDeleteFaq.vue?vue&type=script&lang=js"
export * from "./UndoDeleteFaq.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports